module.exports = __webpack_public_path__ + "assets/img/202112-4W.b8d6a5a1.png";